import Svg, { SvgProps, Path } from "react-native-svg";

const Magazine = (props: SvgProps) => (
  <Svg width={64} height={64} {...props}>
    <Path
      d="M57.8398 11.502H20.0999C18.3758 2.1697 5.31609 3.17081 5 12.6623C5 12.6622 5 51.3683 5 51.3683C5.00021 55.5551 8.40643 58.9617 12.5933 58.9617H51.4067C52.0474 58.9617 52.5668 58.4422 52.5668 57.8015V52.5285H57.8398C58.4806 52.5285 59 52.0091 59 51.3683V12.6622C59 12.0214 58.4806 11.502 57.8398 11.502ZM7.32031 12.6622C7.32031 9.69553 9.68577 7.28198 12.5933 7.28198C15.5009 7.28198 17.8663 9.69553 17.8663 12.6622V45.9094C15.0566 43.0844 10.1293 43.0852 7.32031 45.9094V12.6622ZM50.2465 56.6414H12.5933C9.68577 56.6414 7.32031 54.2759 7.32031 51.3683C7.32031 48.4608 9.68577 46.0953 12.5933 46.0953C15.5009 46.0953 17.8663 48.4608 17.8663 51.3683C17.8663 52.0091 18.3858 52.5285 19.0265 52.5285H50.2465V56.6414ZM56.6797 50.2082C54.084 50.2082 23.6821 50.2082 20.1867 50.2082V13.8223H56.6797V50.2082Z"
      fill="#003067"
    />
    <Path
      d="M51.4067 26.796H41.7571C41.1164 26.796 40.5969 26.2765 40.5969 25.6358V19.2026C40.5969 18.5619 41.1164 18.0425 41.7571 18.0425H51.4067C52.0475 18.0425 52.5669 18.5619 52.5669 19.2026V25.6358C52.5669 26.2765 52.0475 26.796 51.4067 26.796ZM42.9172 24.4757H50.2466V20.3628H42.9172V24.4757Z"
      fill="#C6AA6E"
    />
    <Path
      d="M35.3238 20.3628H25.4596C23.9234 20.303 23.9186 18.1044 25.4596 18.0425H35.3238C35.9645 18.0425 36.484 18.5619 36.484 19.2026C36.484 19.8434 35.9645 20.3628 35.3238 20.3628Z"
      fill="#003067"
    />
    <Path
      d="M35.3238 26.7959H25.4596C23.9234 26.7361 23.9186 24.5375 25.4596 24.4756H35.3238C35.9645 24.4756 36.484 24.995 36.484 25.6357C36.484 26.2765 35.9645 26.7959 35.3238 26.7959Z"
      fill="#003067"
    />
    <Path
      d="M51.4067 33.229H25.4597C23.9284 33.1749 23.9175 30.9673 25.4597 30.9087H51.4067C52.9381 30.9662 52.9524 33.1652 51.4067 33.229Z"
      fill="#003067"
    />
    <Path
      d="M51.4067 39.6621H25.4597C23.9284 39.608 23.9175 37.4004 25.4597 37.3418H51.4067C52.9381 37.3993 52.9524 39.5983 51.4067 39.6621Z"
      fill="#003067"
    />
    <Path
      d="M51.4067 46.0957H25.4597C23.9284 46.0416 23.9175 43.834 25.4597 43.7754H51.4067C52.9381 43.8328 52.9524 46.0318 51.4067 46.0957Z"
      fill="#003067"
    />
  </Svg>
);

export default Magazine;
